import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App, { loadAuthPages } from "@/App";
import { i18nReady } from "@/i18n";
import { publicReady } from "@/public/PublicSite";
import { registerServiceWorker } from "@/lib/pwa";
import { watchViewport } from "@/lib/viewport";

// Keep React working when browser translators or extensions move text nodes (react#11538).
const { removeChild, insertBefore } = Node.prototype;
Node.prototype.removeChild = function (child) {
  if (child.parentNode !== this) return child;
  return removeChild.call(this, child);
};
Node.prototype.insertBefore = function (node, ref) {
  if (ref && ref.parentNode !== this) return insertBefore.call(this, node, null);
  return insertBefore.call(this, node, ref);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
registerServiceWorker();
watchViewport();
// Mount once the page's language files (and any prefetched article) are in, so the first render replaces the pre-painted shell 1:1.
const wait = (ms) => new Promise((r) => setTimeout(r, ms));
const authReady = window.__amAuthShell ? loadAuthPages().catch(() => {}) : null;
Promise.race([Promise.all([i18nReady, publicReady, window.__amPreP, authReady]), wait(4000)]).finally(() => {
  // Keep whatever was typed into the pre-painted auth form, and where the cursor was.
  window.__amTyped = {};
  document.querySelectorAll("#root input[id]").forEach((i) => { window.__amTyped[i.id] = i.value; });
  window.__amFocus = document.activeElement?.id || null;
  root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  );
});
